<section class="flex flex-col gap-12 grow">
    <div class="flex flex-col">
        <h1 class="!font-medium !text-base !m-0">{{ 'manage' | transloco }}</h1>
        <app-role-permission-list [permissionLabels]="managePermissionsLabel()" />
    </div>

    <div class="flex flex-col">
        <h1 class="!font-medium !text-base !m-0">{{ 'toAccess' | transloco }}</h1>
        <app-role-permission-list [permissionLabels]="accessPermissionsLabel()" />
    </div>
</section>
